import { render, staticRenderFns } from "./ArenaList.vue?vue&type=template&id=ba8e9dde&scoped=true"
import script from "./ArenaList.vue?vue&type=script&lang=js"
export * from "./ArenaList.vue?vue&type=script&lang=js"
import style0 from "./ArenaList.vue?vue&type=style&index=0&id=ba8e9dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8e9dde",
  null
  
)

export default component.exports